module.exports = __webpack_public_path__ + "static/media/screenshot-scenarios-step-2.91003803.png";